import Vue from 'vue'
import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const LinkedCalendarsState = {
  linkedCalendars: {
    calendars: [],
    items: [],
  },
}

export const LinkedCalendarsActions = {
  async addLinkedCalendar ({ commit }, { calendarId, service, userId }) {
    return axiosRequest.post('/calendar/linked_calendars', {
      calendar_id: calendarId,
      service,
      user_id: userId,
    }).
      then(({ data }) => {
        commit('setCalendar', {
          id: data.id,
          calendarId: data.calendar_id,
          description: data.description,
          linked: data.linked,
          name: data.name,
          service: data.service,
        })
      }).
      catch(handleError)
  },

  async fetchLinkableCalendars ({ commit }, userId) {
    return axiosRequest.get('/calendar/linked_calendars', {
      params: {
        user_id: userId,
      },
    }).
      then(({ data }) => {
        const calendars = data.map(calendar => {
          return {
            id: calendar.id,
            calendarId: calendar.calendar_id,
            description: calendar.description,
            linked: calendar.linked,
            name: calendar.name,
            service: calendar.service,
          }
        })
        commit('setCalendars', calendars)
      }).
      catch(handleError)
  },

  async fetchLinkedCalendarsItems (_, { endDate, startDate, userIds }) {
    return axiosRequest.get('/calendar/linked_calendars/items', {
      params: {
        user_ids: userIds,
        start_date: startDate,
        end_date: endDate,
      },
    }).
      then(({ data }) => {
        const items = (data || []).map(item => ({
          allDay: item.all_day,
          attendees: item.attendees,
          calendarId: item.calendar_id,
          description: item.description,
          endDate: item.end_date,
          id: item.id,
          itemType: item.item_type,
          link: item.link,
          location: item.location,
          title: item.title,
          service: item.service,
          startDate: item.start_date,
          userId: item.user_id,
        }))

        return items
      }).
      catch(handleError)
  },

  async refreshLinkedCalendarsItems ({ commit, dispatch, state }) {
    const startDate = new Date(
      state.selectedCalendar.date.getFullYear(),
      state.selectedCalendar.date.getMonth(),
      1
    )

    const endDate = new Date(
      state.selectedCalendar.date.getFullYear(),
      state.selectedCalendar.date.getMonth() + 1,
      0
    )

    return dispatch('fetchLinkedCalendarsItems', {
      endDate,
      startDate,
      userIds: [state.selectedCalendar.userId],
    }).
      then(items => commit('setCalendarsItems', items)).
      catch(handleError)
  },

  async removeLinkedCalendar ({ commit }, id) {
    return axiosRequest.delete(`/calendar/linked_calendars/${id}`).
      then(_ => { commit('setCalendarUnlinked', id) }).
      catch(handleError)
  },
}

export const LinkedCalendarsMutations = {
  setCalendar: (state, calendar) => {
    const idx = state.linkedCalendars.calendars.
      findIndex(c => c.service === calendar.service && c.calendarId === calendar.calendarId)

    if (idx < 0) {
      state.linkedCalendars.calendars.push(calendar)
    } else {
      Vue.set(state.linkedCalendars.calendars, idx, calendar)
    }
  },

  setCalendars: (state, calendars) => {
    state.linkedCalendars.calendars = calendars
  },

  setCalendarsItems: (state, items) => {
    state.linkedCalendars.items = items
  },

  setCalendarUnlinked: (state, id) => {
    const calendar = state.linkedCalendars.calendars.find(c => c.id === id)
    if (calendar) { calendar.linked = false }
  },
}

export const LinkedCalendarsGetters = {
  availableCalendarsForLinking: state => state.linkedCalendars.calendars,
  linkedCalendars: state => state.linkedCalendars.calendars.filter(c => c.linked === true),
  linkedCalendarsItems: state => state.linkedCalendars.items,
}
